module.exports = new __parcel__URL__("Charlie_Display-Black_Italic.c3410f6e.woff").toString();